/*
  Livvi Health, redesign stap 4. Geladen via snippets/lv-head.liquid (defer).
  - Leverdatum: vult elk [data-lv-delivery], ook in later ingevoegde HTML (cart drawer na toevoegen).
  - Kuursuggestie in de cart drawer: zet het aantal van regel 1 op 3 via het bestaande aantal-veld.
  - Aanvulling in de cart drawer en winkelwagen (_herkomst: aanvulling) en Passt dazu op de productpagina
    (_herkomst: aanvulling-pdp, opent daarna de drawer).
  - Kaching-stukprijs "/ item" wordt "/ St." (de) of "/ st." (nl); Kaching heeft daar geen tekstveld voor.
  - Na toevoegen opent ook op mobiel de cart drawer (thema-instelling stond op een melding), zodat
    voortgangsbalk, kuursuggestie en leverdatum in beeld komen.
*/
(function () {
  function initDelivery(scope) {
    (scope || document).querySelectorAll('[data-lv-delivery]:not([data-done])').forEach(function (el) {
      el.setAttribute('data-done', '');
      var holidays = (el.dataset.holidays || '').split(',').map(function (s) { return s.trim(); });
      var nl = el.dataset.nl === 'true';
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
      var get = function (t) { return parseInt(parts.find(function (p) { return p.type === t; }).value, 10); };
      var day = new Date(Date.UTC(get('year'), get('month') - 1, get('day')));
      var hour = get('hour');
      var iso = function (d) { return d.toISOString().slice(0, 10); };
      var isWorkday = function (d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && holidays.indexOf(iso(d)) === -1; };
      var nextWorkday = function (d) { var n = new Date(d); do { n.setUTCDate(n.getUTCDate() + 1); } while (!isWorkday(n)); return n; };
      var start = (isWorkday(day) && hour < 21) ? day : nextWorkday(day);
      var first = nextWorkday(start);
      var lang = el.dataset.locale === 'de' ? 'de-DE' : 'nl-NL';
      var fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'numeric', timeZone: 'UTC' });
      var text = nl
        ? (el.dataset.tplSingle || '').replace('%1', fmt.format(first))
        : (el.dataset.tplBetween || '').replace('%1', fmt.format(first)).replace('%2', fmt.format(nextWorkday(first)));
      var target = el.querySelector('[data-lv-delivery-text]');
      if (target && text) target.textContent = text;
    });
  }
  window.lvDeliveryInit = initDelivery;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lv-kur]');
    if (!btn) return;
    var input = document.getElementById('Drawer-quantity-1') || document.querySelector('cart-drawer input[name="updates[]"]');
    if (!input) return;
    btn.classList.add('is-loading');
    input.value = 3;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // "Ergänzend zu Ihrer Bestellung" (snippets/lv-cart-addon.liquid): één stuk toevoegen met de verborgen
  // regel-eigenschap _herkomst, daarna de drawer verversen via het thema; op de winkelwagenpagina herladen.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lv-addon]');
    if (!btn || btn.classList.contains('is-loading')) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    var drawer = document.querySelector('cart-drawer');
    var fromPdp = btn.dataset.origin === 'pdp';
    // Productpagina: na toevoegen de drawer verversen en openen. Winkelwagenpagina: herladen.
    var onCartPage = document.body.classList.contains('template-cart') || !drawer || (!fromPdp && !btn.closest('cart-drawer'));
    var body = { items: [{ id: Number(btn.dataset.variant), quantity: 1, properties: { _herkomst: fromPdp ? 'aanvulling-pdp' : 'aanvulling' } }] };
    if (!onCartPage && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { btn.classList.remove('is-loading'); btn.disabled = true; return; }
        if (onCartPage) { window.location.reload(); return; }
        if (res.sections && typeof drawer.renderContents === 'function') drawer.renderContents({ sections: res.sections });
        else { window.location.reload(); return; }
        if (fromPdp) {
          btn.classList.remove('is-loading');
          if (typeof drawer.open === 'function') drawer.open();
        }
      })
      .catch(function () { btn.classList.remove('is-loading'); });
  });

  // Productkaarten (snippets/lv-product-card.liquid) zijn gewone formulieren naar /cart/add en stuurden
  // daardoor door naar de winkelwagenpagina. Hier toevoegen via /cart/add.js en de drawer openen
  // (fix livegang 20 oktober 2026). De product-form van het thema handelt zijn eigen formulier al af.
  function openDrawer(drawer) {
    if (typeof drawer.open === 'function') drawer.open();
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]') || form.closest('product-form')) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || document.body.classList.contains('template-cart') || typeof drawer.renderContents !== 'function') return;
    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { if (btn.classList.contains('is-loading')) return; btn.classList.add('is-loading'); }
    var body = { items: [{ id: Number(idInput.value), quantity: 1 }] };
    if (typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (res.status) { if (btn) btn.disabled = true; return; }
        if (res.sections) drawer.renderContents({ sections: res.sections });
        openDrawer(drawer);
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); form.submit(); });
  });

  // Winkelwagenicoon in lv-header is een link naar /cart; opent nu de drawer, behalve op de winkelwagenpagina.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('#cart-icon-bubble');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || document.body.classList.contains('template-cart') || typeof drawer.open !== 'function') return;
    e.preventDefault();
    openDrawer(drawer);
  });

  try {
    if (window.themeGlobalVariables && themeGlobalVariables.settings) themeGlobalVariables.settings.actionAddCartMobile = 'mini_cart';
  } catch (e) {}

  var unitLabel = (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0 ? 'St.' : 'st.';
  function fixKachingUnit(scope) {
    (scope || document).querySelectorAll('.kaching-bundles__bar-unit-price').forEach(function (el) {
      var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        if (/\/\s*item\b/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/\/\s*item\b/i, '/ ' + unitLabel);
        else if (/^\s*item\b/i.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/^(\s*)item\b/i, '$1' + unitLabel);
      }
    });
  }

  function boot() {
    initDelivery();
    fixKachingUnit();
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].addedNodes.length || list[i].type === 'characterData') { initDelivery(); fixKachingUnit(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
